import React, { CSSProperties, PropsWithChildren } from 'react'

const styles = {
    root: {
        display: 'inline-block',
        width: '26px',
        height: '26px',
        lineHeight: '26px',
        boxShadow: 'rgb(204, 204, 204) 1px 1px 3px',
        position: 'relative',
        fontWeight: 'bold',
        color: 'rgb(255, 255, 255)',
        textAlign: 'center',
        cursor: 'pointer',
        marginRight: '5px',
        marginLeft: '5px',
    } as CSSProperties,
    success: {
        background: 'green',
    } as CSSProperties,
    fail: {
        background: 'red',
    } as CSSProperties,
    circle: {
        borderRadius: '50%',
    },
}

interface Props {
    type: 'success' | 'fail'
    title: string
    shape?: 'circle' | 'rect'
}

const Badge: React.FC<PropsWithChildren<Props>> = (props) => {
    const { shape = 'rect' } = props

    return (
        <span
            style={{
                ...styles.root,
                ...(props.type === 'success' ? styles.success : styles.fail),
                ...(shape === 'rect' ? null : styles.circle),
            }}
            title={props.title}
        >
            {props.children}
        </span>
    )
}

export default Badge
